import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["button", "panel", "title"];

  connect() {
    this.buttonTarget.setAttribute("aria-controls", this.panelTarget.id);
    this.sync();
  }

  open(event) {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;

    event.preventDefault();
    this.panelTarget.hidden = false;
    this.sync();
    this.titleTarget.focus();
  }

  close() {
    if (this.panelTarget.hidden) return;

    this.panelTarget.hidden = true;
    this.sync();
    this.buttonTarget.focus();
  }

  sync() {
    const open = !this.panelTarget.hidden;
    this.buttonTarget.hidden = open;
    this.buttonTarget.setAttribute("aria-expanded", String(open));
  }
}
